import React from "react";
import Context from "../../Context";
import { Modal } from "react-bootstrap";
import Product from "../Layout/Product/Product";

export default class ProductPicker extends React.Component {
  static contextType = Context;
  constructor(props) {
    super(props);

    const { defaultValue, defaultItem = {} } = this.props;

    this.state = {
      pending: false,
      valueItem: defaultItem,
      value: defaultValue,
      modal: false,
      storage: null,
    };
  }
  componentDidMount() {
    this.load();
  }
  componentDidUpdate(prevProps) {
    if (prevProps.defaultValue !== this.props.defaultValue) {
      const { defaultValue, defaultItem = {} } = this.props;
      this.setState({ valueItem: defaultItem, value: defaultValue }, () =>
        this.load()
      );
    }
  }

  load = async () => {
    const { valueItem, value } = this.state;
    if (value && valueItem.id !== value) {
      this.setState({ pending: true });
      let valueItemQuery = await this.context.api.q(`/document/get`, {
        id: value,
      });
      this.setState({ valueItem: valueItemQuery || {}, pending: false });
    }
  };

  onStorageChange = (storage) => {
    this.setState({ storage });
  };

  openModal = () => {
    this.setState({ modal: true });
  };

  closeModal = () => {
    this.setState({ modal: false });
  };

  onChange = (product) => {
    if (this.props.onChange) {
      this.props.onChange(product.id);
    }
    this.closeModal();
  };

  render() {
    const { pending, valueItem, modal, storage } = this.state;

    return (
      <>
        {modal && (
          <Modal size="lg" show onHide={this.closeModal}>
            <Modal.Body>
              <Product
                storageId={storage}
                onStorageChange={this.onStorageChange}
                onProductPick={this.onChange}
              />
            </Modal.Body>
          </Modal>
        )}
        <div className="input-group">
          <input
            type="text"
            className="form-control"
            value={valueItem.modelname || valueItem.label || ""}
            onDoubleClick={this.openModal}
            readOnly
          />
          <div className="input-group-append">
            {pending ? (
              <div className="btn btn-icon border">
                <span
                  className="spinner-border spinner-border-sm text-muted"
                  role="status"
                  aria-hidden="true"
                ></span>
              </div>
            ) : (
              <button
                title="Выбрать"
                className="btn btn-icon border"
                type="button"
                onClick={this.openModal}
              >
                <i className="fa icon-md text-muted fa-navicon"></i>
              </button>
            )}
          </div>
        </div>
      </>
    );
  }
}
